import * as components from './components'

export default [
  {
    path: '/careerIdea',
    component: components.CareerIdea,
    name: 'careerIdea'
  },
  {
    path: '/careerIdea/create',
    component: components.CareerIdeaCreate,
    name: 'careerIdeaCreate'
  },
  {
    path: '/careerIdea/:careerIdeaId/edit',
    component: components.CareerIdeaCreate,
    name: 'careerIdeaEdit',
    props: true
  },
  {
    path: '/careerIdea/:careerIdeaId/connection',
    component: components.Connection,
    name: 'connection',
    props: true
  },
  {
    path: '/careerIdea/:careerIdeaId/connection/create',
    component: components.ConnectionCreate,
    name: 'connectionCreate',
    props: true
  },
  {
    path: '/careerIdea/:careerIdeaId/connection/:connectionId/edit',
    component: components.ConnectionCreate,
    name: 'connectionEdit',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/quest/routes.js